import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';

// devices routing
const MSG91 = Loadable(lazy(() => import('./msg91/MSG91')));
const EmailWIthGmailConfig = Loadable(lazy(() => import('./gmail/EmailWithGmailConfig')));
const NotificationGroups = Loadable(lazy(() => import('./groups/NotificationGroups')));

// ==============================|| MAIN ROUTING ||============================== //

const NotificationProviderRoutes = {
    path: 'notificationProvider',
    children: [
        {
            path: 'msg91',
            element: <MSG91 />
        },
        {
            path: 'gmail',
            element: <EmailWIthGmailConfig />
        },
        {
            path: 'groups',
            element: <NotificationGroups />
        }
    ]
};

export default NotificationProviderRoutes;
